import React from 'react';
import { Card } from '@mts/ui';
import { Pencil } from 'lucide-react';
import BasicAddressCard from './BasicAddressCard';
import BasicContactActions from './BasicContactActions';

function BasicContactCard({ phone, website, email, phoneField, websiteField, emailField, address, addressField, canEdit = false, onEdit }) {
  if (!canEdit && ![phone, website, email, address].some(value => String(value || '').trim())) return null;

  return (
    <div id="ContactCard">
      <Card
        id="ContactCard-Card"
        className="my-[10px] rounded-lg"
        style={{
          backgroundColor: 'var(--card)',
          borderColor: 'var(--border)',
          borderWidth: '1px',
          borderStyle: 'solid',
        }}
      >
      <Card.Header id="ContactCard-CardHeader" className="flex items-start justify-between gap-3">
        <div id="ContactCard-CardHeaderInner">
          <h2 className="text-base font-semibold text-[var(--primary)]">Contact</h2>
          <Card.Title id="ContactCard-CardTitle">
            <span className="sr-only">Contact details</span>
          </Card.Title>
          <Card.Description id="ContactCard-CardDescription">
            <span className="sr-only">Business contact information</span>
          </Card.Description>
        </div>
        <Card.Action id="ContactCard-CardAction">
          {canEdit ? (
            <button
              type="button"
              aria-label="Edit Contact"
              title="Edit Contact"
              onClick={onEdit}
              className="inline-flex h-9 w-9 items-center justify-center rounded-md border border-[var(--border)] text-[var(--primary)] transition-colors hover:bg-black/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--primary)]/30"
            >
              <Pencil size={16} aria-hidden="true" />
            </button>
          ) : (
            <div />
          )}
        </Card.Action>
      </Card.Header>

      <Card.Content id="ContactCard-CardContent" className="before:content-none after:content-none">
        <BasicContactActions
          phone={phone}
          website={website}
          email={email}
          phoneField={phoneField}
          websiteField={websiteField}
          emailField={emailField}
        />
        <BasicAddressCard address={address} addressField={addressField} />
      </Card.Content>

      <Card.Footer id="ContactCard-CardFooter">
        <div />
      </Card.Footer>
      </Card>
    </div>
  );
}

export default BasicContactCard;
